import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { BazaNcBankAccountType, BazaNcBootstrapDto } from '@scaliolabs/baza-nc-shared';
import { BazaWebUtilSharedService } from '@scaliolabs/baza-web-utils';

import { GetDefaultBankAccount, PurchaseState, PurchaseService } from '../../../data-access';
import { PurchaseAccountPayoutBankComponent } from '../payout-bank/payout-bank.component';

@Component({
    selector: 'app-purchase-account-payout',
    templateUrl: './payout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, PurchaseAccountPayoutBankComponent, NzGridModule, NzSkeletonModule],
})
export class PurchaseAccountPayoutComponent {
    @Input()
    initData?: BazaNcBootstrapDto;

    @Input()
    isAnyAssetPurchased = false;

    @Input()
    header?: TemplateRef<any>;

    dwollaDefaultCashOutAccount$ = this.store.select(PurchaseState.dwollaDefaultCashOutAccount);

    constructor(
        public readonly purchaseService: PurchaseService,
        private readonly store: Store,
        private readonly wts: BazaWebUtilSharedService,
    ) {
        this.loadData();
    }

    loadData() {
        this.store.dispatch(new GetDefaultBankAccount(BazaNcBankAccountType.CashOut, { throwError: false }));
    }

    onRefreshCashOutData() {
        this.wts.refreshInitData$.next();
        this.loadData();
    }
}
